import * as Toast from '@radix-ui/react-toast';
import styled from 'styled-components';

export const ToastRoot = styled(Toast.Root)<{
  $hasAction: boolean;
  $status?: string;
  $type?: string;
}>`
  --viewport-padding: 12px;
  display: grid;
  grid-template-areas: 'title action' 'description action';
  grid-template-columns: auto max-content;
  column-gap: 0;
  align-items: center;
  cursor: pointer;
  padding: 12px;

  border-radius: 8px;
  background: rgba(52, 52, 52, 0.85);
  box-shadow: 0 8px 48px 24px #131315;
  backdrop-filter: blur(9px);

  position: relative;
  overflow: hidden;

  width: 100%;
  padding-right: 40px;

  &[data-state='open'] {
    /* animation: slideIn 150ms cubic-bezier(0.16, 1, 0.3, 1); */
  }

  &[data-state='closed'] {
    animation: hide 100ms ease-in;
  }

  &[data-swipe='move'] {
    transform: translateX(var(--radix-toast-swipe-move-x));
  }

  &[data-swipe='cancel'] {
    transform: translateX(0);
    transition: transform 200ms ease-out;
  }

  &[data-swipe='end'] {
    animation: swipeOut 100ms ease-out;
  }

  @keyframes hide {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @keyframes slideIn {
    from {
      transform: translateY(calc(-100% - var(--viewport-padding)));
    }
    to {
      transform: translateY(0);
    }
  }

  @keyframes swipeOut {
    from {
      transform: translateX(var(--radix-toast-swipe-end-x));
    }
    to {
      transform: translateX(calc(100% + var(--viewport-padding)));
    }
  }
`;

export const ToastViewport = styled(Toast.Viewport)`
  position: fixed;
  top: 64px;
  right: 50%;
  transform: translate(50%, 0%);
  display: flex;
  flex-direction: column;
  // padding: 24px 0;
  gap: 10px;
  max-width: 480px;
  width: calc(100% - 24px);
  margin: 0;
  list-style: none;
  z-index: 2147483647;
  outline: none;
`;

export const ToastClose = styled(Toast.Close)`
  position: absolute;
  top: 12px;
  right: 12px;
  background-color: transparent;
  border: none;
  padding: 0;
  display: grid;
  place-items: center;
  cursor: pointer;
  opacity: 0.6;
  z-index: 1;

  &:hover {
    opacity: 1;
  }
`;

export const ToastProgress = styled.div<{ $status?: string }>`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  transform-origin: left;
  background: rgba(255, 255, 255, 0.5);

  ${({ $status }) =>
    $status === 'success' &&
    `
    background: var(--Green, #08AD5E);`}
  ${({ $status }) =>
    $status === 'error' &&
    `
    background: var(--Red, #DA4444);`}
`;
